 
import { usePosition } from '../../custom_hooks/usePosition';
import moment from 'moment'
import { React, useEffect, useState, Fragment, useCallback, useRef, useMemo, useContext } from "react";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, TEMPLATES_URL, ENDPOINTS, LOCAL_PARAMS } from "../../Constants";
import { getTemplateByName, genericPost, genericGet } from "../../services/Api";
import { EbmsLoading, localizeData, getLocalizeData, resetLocalizeData, isObjectEmpty, log, getUniqueString } from "../../services/Utils";

import { Spinner } from "reactstrap";
import { useHistory, Link, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
// import * as d3 from "d3";
import "./style.css";
import * as FaIcons from 'react-icons/fa';
import * as SurveyCore from "survey-core";
import { Survey } from 'survey-react-ui';
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FileSaver, saveAs } from 'file-saver';
import * as Alerts from '../customs/Alerts'
import { getDb as myDb } from '../../services/DbHelper';
import { useLiveQuery } from "dexie-react-hooks";

import AppContext from "../../AppContext";
SurveyCore.StylesManager.applyTheme("defaultV2");
const InlineWebSurveys = (props) => {
    const global = useContext(AppContext);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    // const [user, setUser] = useState({});
    const [surveyModel, setSurveyModel] = useState(new SurveyCore.Model({}));
    const [surveyDetails, setSurveyDetails] = useState({});
    const [surveyModelData, setSurveyModelData] = useState({});
    const [currentUser, setCurrentUser] = useState({});
    const [ipAddress, setIpAddress] = useState("");
    const [isHidden, setIsHidden] = useState(true);
    const [showLocationAlert, setShowLocationAlert] = useState(true);
    const survey_token = useParams();
    // let params = props.location.state;
    let startedAt =moment(new Date()).format('YYYY-MM-DD HH:mm:ss');// moment(new Date(), 'YYYY-mm-D H:mm:ss');
    let surveyResponses = {};

    let db = myDb();
    let params = {};
    let user = null;
    // const [alertSettings, setAlertSettings] = useState({
    //     "id": "confirm-modal",
    //     "type": "warning",
    //     "title": "<h3>Hey, Are you sure?</h3>",
    //     "message": "here we go",//"<p>You are about to delete beneficiary named Moses whose telephone is: 6102523233</p>",
    //     "action": (() => {
    //         log("This is okay");
    //     })
    // });
    //    let user= global.get_logged_in_user();
    //    setIpAddress(global.get_user_ip_details());
    const { latitude, longitude, error } = usePosition();
    // log("latitude",latitude);
    // log("longitude",longitude);
    // const submitSurveyResponses = (responses) => {


    // const submitSurveyResponses = async (responses) => {
    //     // log('responses', responses);

    //     // if (isObjectEmpty(params, 'id') || !(surveyDetails["version"])) {
    //     if (isObjectEmpty(params, 'survey_id') || (isObjectEmpty(params, 'version'))) {
    //         cogoToast.error("Warning!! Invalid request. Check the link you are loading and try again.", {});
    //         return;
    //     }
    //     // log("startedAt", startedAt);
    //     let endedAt = moment(new Date(), 'YYYY-mm-D H:mm:ss');
    //     // log("endedAt", endedAt);

    //     let reqData = {
    //         "sync_token": syncToken,
    //         "token": params['token'],
    //         "survey_responses": responses,
    //         "ip_address": JSON.stringify(global.get_user_ip_details()),
    //         "location": JSON.stringify({ "latitude": latitude, "longitude": longitude }),
    //         "version": params["version"],
    //         "started_at": startedAt,
    //         "ended_at": endedAt,
    //         // "user_id": user["usertoken"]
    //     };
    //     log("reqData", reqData);
    //     setIsLoading(true);
    //     genericPost(ENDPOINTS.POST_WEB_SURVEY_RESPONSES, reqData)
    //         .then((res) => {
    //             if (res.status == 200) {
    //                 if (res.data.status == SUCCESS_RESULT) {
    //                     setIsHidden(false);
    //                     // localStorage.setItem("SAVED_SURVEY","Survye-Done");
    //                     cogoToast.success(res.data.message, {});
    //                     // setAlertSettings({
    //                     //     "id": "confirm",
    //                     //     "type": "warning",
    //                     //     "title": "<h3>Hey, Are you sure?</h3>",
    //                     //     "message": "here we go",//"<p>You are about to delete beneficiary named Moses whose telephone is: 6102523233</p>",
    //                     //     "action": (() => {
    //                     //         log("This is okay");
    //                     //     })
    //                     // });
    //                     // var tabHyperLink = document.createElement("a");
    //                     // tabHyperLink.href = "javascript:void(0);";
    //                     // tabHyperLink.innerHTML = "data-bs-toggle='modal' data-bs-target='#confirm' ";
    //                     // setTimeout(()=>{
    //                     //     log("WORKING NOW","NOW");                          
    //                     //     tabHyperLink.click();
    //                     // },2000)

    //                 } else {
    //                     setIsHidden(true);
    //                     cogoToast.error(res.data.message, {});
    //                 }
    //             } else {
    //                 setIsHidden(true);
    //                 cogoToast.error("Connection error. Please try again.", {});
    //             }
    //             setIsLoading(false);
    //         })
    //         .catch((err) => {
    //             setIsHidden(true);
    //             setIsLoading(false);
    //             cogoToast.error("Critical error occurred. Please try again.", {});
    //         });
    // };


    useEffect(() => {

        // if (isObjectEmpty(params, 'survey_id') || (isObjectEmpty(params, 'questionnaire'))) {
        //     cogoToast.error("Warning!! Invalid request. Check the link you are loading and try again.", {});
        //     history.push({
        //         pathname: "/ebms/surveys/ongoing",
        //     });
        //     return;
        // }
        getQuestionnaire();
        getUserDetails();
        // setSurveyModel(new SurveyCore.Model(params["questionnaire"]))
        document.title = params["name"];
        //   user =  global.get_logged_in_user();
        // if(isObjectEmpty(user,"usertoken")){
        // history.push({
        //             pathname: "/ebms/surveys/ongoing",
        //         });
        //     }
    }, []);
    function getQuestionnaire() {
        // log("survey_tokenm", survey_token["id"]);
        // First try to load from local DB (for offline support)
        return db.transaction('r', [db.surveys, db.submissions], async () => {
            try {
                const localSurvey = await db.surveys.get({ token: survey_token["id"] });
                
                if (localSurvey && localSurvey.questionnaire) {
                    // Found in local DB - use it
                    log("SURVEY loaded from local DB>>>>:: ", localSurvey);
                    
                    // Parse questionnaire if it's a string
                    let questionnaire = localSurvey.questionnaire;
                    if (typeof questionnaire === 'string') {
                        try {
                            questionnaire = JSON.parse(questionnaire);
                        } catch (e) {
                            log("Error parsing questionnaire from local DB", e);
                            // If parsing fails, try fetching from API
                            loadSurveyFromAPI();
                            return;
                        }
                    }
                    
                    // Validate questionnaire has pages
                    if (!questionnaire || !questionnaire.pages || questionnaire.pages.length === 0) {
                        log("Local survey has no pages, fetching from API...");
                        loadSurveyFromAPI();
                        return;
                    }
                    
                    params = localSurvey;
                    setSurveyDetails(localSurvey);
                    setSurveyModel(new SurveyCore.Model(questionnaire));
                    document.title = params["name"];
                    return localSurvey;
                } else {
                    // Not found locally - fetch from API
                    log("Survey not found in local DB, fetching from API...");
                    loadSurveyFromAPI();
                }
            } catch (e) {
                log("Error loading from local DB, fetching from API", e);
                loadSurveyFromAPI();
            }
        }).catch((e) => {
            // If DB transaction fails, fetch from API
            log("DB transaction failed, fetching from API", e);
            loadSurveyFromAPI();
        });
    }

    const loadSurveyFromAPI = () => {
        if (!survey_token || !survey_token["id"]) {
            cogoToast.error("Invalid survey token. Please check the link.", {});
            return;
        }
        
        setIsLoading(true);
        genericPost(ENDPOINTS.LOAD_WEB_SURVEY_DETAILS, { "token": survey_token["id"] })
            .then(async (res) => {
                setIsLoading(false);
                if (res.status === 200) {
                    if (res.data.status === SUCCESS_RESULT) {
                        let rawData = res.data;
                        if (!rawData['data']) {
                            cogoToast.error("Survey data not found. Please check the link.", {});
                            return;
                        }
                        
                        let surveyDetails = rawData.data;
                        document.title = surveyDetails['name'] || "Survey";
                        setSurveyDetails(surveyDetails);
                        
                        // Parse questionnaire if it's a string
                        let questionnaire = surveyDetails['questionnaire'];
                        if (typeof questionnaire === 'string') {
                            try {
                                questionnaire = JSON.parse(questionnaire);
                            } catch (e) {
                                log("Error parsing questionnaire", e);
                                cogoToast.error("Invalid survey questionnaire format.", {});
                                return;
                            }
                        }
                        
                        // Validate questionnaire has pages
                        if (!questionnaire || !questionnaire.pages || questionnaire.pages.length === 0) {
                            cogoToast.error("The survey doesn't contain visible pages or questions. Please contact the survey administrator.", {});
                            return;
                        }
                        
                        setSurveyModel(new SurveyCore.Model(questionnaire));
                        params = surveyDetails;
                        
                        // Save to local DB for offline access
                        try {
                            await db.transaction('rw', [db.surveys], async () => {
                                await db.surveys.put({
                                    ...surveyDetails,
                                    token: survey_token["id"],
                                    questionnaire: typeof questionnaire === 'string' ? questionnaire : JSON.stringify(questionnaire)
                                });
                            });
                        } catch (e) {
                            log("Error saving survey to local DB", e);
                            // Continue even if save fails
                        }
                    } else {
                        cogoToast.error(res.data.message || "Failed to load survey", {});
                    }
                } else {
                    cogoToast.error("Connection error. Please try again.", {});
                }
            })
            .catch((err) => {
                setIsLoading(false);
                log("Error loading survey from API", err);
                cogoToast.error("Failed to load survey. Please check your connection and try again.", {});
            });
    };
    function getUserDetails() {
        // log("survey_tokenm", survey_token["id"]);
        // Make user details optional for public access
        return db.transaction('r', [db.user], async () => {
            try {
                const theUser = await db.user.toArray();
                log("theUser>>>>:: ", theUser);
                if(theUser.length > 0) {
                    setCurrentUser(theUser[0]);
                } else {
                    // No user found - allow public access
                    setCurrentUser(null);
                }
                return theUser;
            } catch (e) {
                // If user table doesn't exist or error, allow public access
                log("No user data available - allowing public access", e);
                setCurrentUser(null);
                return [];
            }
        }).catch((e) => {
            // Allow public access if user lookup fails
            log("User lookup failed - allowing public access", e);
            setCurrentUser(null);
        });
    }
    const saveSubmissionOffline = async (responses) => {
        let endedAt = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        let syncToken = getUniqueString(32);
        const isAuthenticated = currentUser && currentUser["usertoken"];
        
        let reqData = {
            sync_token: syncToken,
            token: survey_token["id"],
            survey_responses: responses,
            ip_address: JSON.stringify({}),
            location: JSON.stringify({ "latitude": latitude || null, "longitude": longitude || null }),
            version: surveyDetails["version"],
            started_at: ""+startedAt,
            ended_at: ""+endedAt,
        };
        
        // Only include user_id if user is logged in (for public access)
        if (isAuthenticated) {
            reqData.user_id = currentUser["usertoken"];
        }
        
        log("reqData", reqData);
        
        // Try to post directly to API
        setIsLoading(true);
        try {
            const apiResponse = await genericPost(ENDPOINTS.POST_WEB_SURVEY_RESPONSES, reqData);
            
            if (apiResponse.status === 200) {
                if (apiResponse.data.status === SUCCESS_RESULT) {
                    setIsLoading(false);
                    cogoToast.success(apiResponse.data.message || "Survey submitted successfully!", {});
                    setIsHidden(false);
                    
                    // Also save to local DB with sync_status = 10001 (synced) for authenticated users
                    if (isAuthenticated) {
                        try {
                            await db.transaction('rw', [db.submissions], async () => {
                                await db.submissions.add({
                                    ...reqData,
                                    sync_status: "10001" // Mark as synced
                                });
                            });
                        } catch (e) {
                            log("Error saving synced submission to local DB", e);
                        }
                    }
                    return;
                } else {
                    // API returned error
                    setIsLoading(false);
                    cogoToast.error(apiResponse.data.message || "Failed to submit survey. Please try again.", {});
                    return;
                }
            }
        } catch (apiError) {
            // API call failed (offline or network error)
            setIsLoading(false);
            
            if (!isAuthenticated) {
                // For unauthenticated users, reject and require internet
                cogoToast.error("Internet connection is required to submit this survey. Please check your connection and try again.", {
                    hideAfter: 8,
                });
                return;
            }
            
            // For authenticated users, save to local DB for later sync
            log("API call failed, saving offline for authenticated user", apiError);
            try {
                await db.transaction('rw', [db.surveys, db.submissions], async function () {
                    await db.submissions.add({
                        ...reqData,
                        sync_status: "10000" // Mark as not synced
                    });
                });
                cogoToast.success("You have successfully saved the survey. Your submission will be synchronized when online.", {});
                setIsHidden(false);
            } catch (e) {
                log("Error saving to local DB", e);
                cogoToast.error("Warning!! Your survey was not saved. " + e, {});
            }
        }
    };
    const onCompleteComponent = () => {
        //   log("DONBE: ",surveyModel.data);
        surveyResponses = surveyModel.data;
        setSurveyModelData(surveyResponses);
        // submitSurveyResponses(JSON.stringify(surveyResponses));
        //SAVE OFFLINE
        saveSubmissionOffline(JSON.stringify(surveyResponses));
    }
    // surveyModel.showNavigationButtons = false;
    // const surveyComplete = useCallback((sender) => {
    //     surveyResponses = surveyModel.data;
    //     setSurveyModelData(surveyResponses);
    //     submitSurveyResponses(JSON.stringify(surveyResponses));
    //   }, []);

    //   surveyModel.onComplete.add(surveyComplete);
    const surveyCss = {
        actionBar: {
            root: "sd-action-bar custom-actionbar-root",
        },
        navigation: {
            complete: "sd-btn--action sd-navigation__complete-btn custom-btn btn-info",
            prev: "sd-navigation__prev-btn custom-btn",
            next: "sd-navigation__next-btn custom-btn",
            start: "sd-navigation__start-btn custom-btn",
            preview: "sd-navigation__preview-btn custom-btn",
        },


    }
    
    const hasLocation = latitude && longitude && !error;

    return (
        <div>
            <Breadcrumb style={{ backgroundColor: '#ffffff' }} className="ms-1 p-2">
                <BreadcrumbItem>
                    <Link to="/ebms"> EBMS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem >
                    <Link to="/ebms/surveys"> SURVEYS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem >
                    <Link to="/ebms/surveys/ongoing"> ONGOING SURVEYS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    <Link to="#"> {params["name"]} </Link>
                </BreadcrumbItem>
            </Breadcrumb>
            
            {/* Location Alert Panel */}
            {(!hasLocation || error) && showLocationAlert && (
                <div style={{ 
                    margin: "10px", 
                    padding: "15px 20px",
                    backgroundColor: "#fff3cd",
                    border: "1px solid #ffc107",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", flex: 1 }}>
                        <FaIcons.FaMapMarkerAlt style={{ fontSize: "24px", color: "#ff9800" }} />
                        <div style={{ flex: 1 }}>
                            <strong style={{ color: "#856404", display: "block", marginBottom: "5px" }}>
                                Location Access Required
                            </strong>
                            <div style={{ color: "#856404", fontSize: "14px" }}>
                                {error ? (
                                    <span>{error}. Please enable location access in your browser settings and refresh this page.</span>
                                ) : (
                                    <span>Location access is required for this survey. Please enable location permissions in your browser.</span>
                                )}
                            </div>
                            <div style={{ marginTop: "10px", fontSize: "13px", color: "#856404" }}>
                                <strong>How to enable:</strong>
                                <ul style={{ margin: "5px 0 0 20px", padding: 0 }}>
                                    <li>Click the lock icon or location icon in your browser's address bar</li>
                                    <li>Select "Allow" for location access</li>
                                    <li>Refresh this page</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Button
                            color="warning"
                            size="sm"
                            onClick={() => window.location.reload()}
                            style={{ 
                                background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
                                border: "none",
                                fontWeight: "600"
                            }}
                        >
                            <FaIcons.FaSyncAlt style={{ marginRight: "5px" }} />
                            Refresh Page
                        </Button>
                        <Button
                            color="link"
                            size="sm"
                            onClick={() => setShowLocationAlert(false)}
                            style={{ color: "#856404", textDecoration: "none" }}
                        >
                            <FaIcons.FaTimes />
                        </Button>
                    </div>
                </div>
            )}

            <div style={{ marginRight: "10px", marginLeft: "10px" }} className="row">
                <center><EbmsLoading data={isLoading} /></center>
                <div style={{ margin: "20px", backgroundColor: "#ffffff" }} class="pull-center">
                    <Survey css={surveyCss} model={surveyModel}
                        data={surveyModelData} onComplete={onCompleteComponent}
                    /> 
                    <Button hidden={isHidden}
                        className="btn btn-info pull-right"
                        onClick={() => {
                            getQuestionnaire();
                            setIsHidden(true);
                            setSurveyModelData({});
                            setSurveyModel(new SurveyCore.Model(params["questionnaire"]));
                        }}
                    >
                        + New Survey
                    </Button>
                </div>
            </div>
            {/* <Alerts.ConfirmationAlert settings={alertSettings} /> */}
        </div>
    );
};

export default InlineWebSurveys;